import { ProductViewConfigurator } from '~/types/configurator';

export default {
    controls: [
        {
            key: 'size',
            keyLabel: 'size',
            label: 'Size',
            choices: [
                {
                    label: '4.3” diameter circle with 0.75″ pull tab, delivered on a 4.3” x 4.5” sheet',
                    value: 4.3,
                },
            ],
            hideOnProductPage: true,
        },
    ],
} as ProductViewConfigurator;
